import styled from 'styled-components';

export const StyledContainer = styled.div`
    max-width: 80%;
    text-align: center;
`;